import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from '../../../hooks';

import { AuthState } from '../types';
import { LOGIN } from '../routes';

type ProtectedRouteProps = {
  children: React.ReactNode;
};

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const state: AuthState = useAppSelector((state) => state.auth);

  const isLoggedIn = state.session.logged;

  if (!isLoggedIn) {
    return <Navigate to={LOGIN()} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
